import React from "react";
import { useSelector } from "react-redux";

import { AVAILABLE } from "@/constants/event";
import dayjs from "@/lib/helpers/dayjs";

import { ScheduleDeleteAvailableModal } from "./ScheduleDeleteAvailableModal";
import { ScheduleDeleteAwayModal } from "./ScheduleDeleteAwayModal";
import { ScheduleDeleteSessionModal } from "./ScheduleDeleteSessionModal";

import "./ScheduleDeleteDialog.scss";

const AWAY = "away";
const VIDEO = "video";

export function ScheduleDeleteDialog({ callId, cancelDelete, scheduleDelete, type }) {
  const provider = useSelector((state) => state.provider);
  const calendar = useSelector((state) => state.calendar);

  let callInfo;

  if (type === VIDEO) {
    callInfo = provider.scheduleCallList.callList.find((call) => call.callId === callId);
  }

  if (type === AWAY && !callId) {
    callInfo = {};
  }

  if (!callInfo) {
    // check if call exists in the viewable events on screen
    const calendarEvents = calendar?.events ?? [];

    callInfo = calendarEvents.find((call) => call.callId === callId);

    // if it does not it must exist in the list of selected events
    if (!callInfo) {
      const selectedEvents = calendar?.selectedEvents ?? [];

      callInfo = selectedEvents.find((call) => call.callId === callId);
    }
  }

  const { event_type, series_id, timestamp } = callInfo;

  const dateTimeLocal = dayjs.utc(timestamp, "YYYY-MM-DD HH:mm").local();

  const sessionDeleteHandler = (cancellationReason, twentyFourNotice, shouldDeleteSeries) => {
    scheduleDelete(cancellationReason, twentyFourNotice, shouldDeleteSeries);
  };

  const availabilityDeleteHandler = (deleteSeries) => {
    const shouldDeleteSeries = deleteSeries === "this_and_future_events";

    scheduleDelete(null, null, shouldDeleteSeries);
  };

  return (
    <>
      {type === VIDEO && event_type !== AVAILABLE && (
        <ScheduleDeleteSessionModal
          callInfo={callInfo}
          onCancel={cancelDelete}
          onSubmit={sessionDeleteHandler}
          type={type}
        />
      )}

      {type === AWAY && (
        <ScheduleDeleteAwayModal
          isRecurring={Boolean(series_id)}
          onCancel={cancelDelete}
          onSubmit={availabilityDeleteHandler}
        />
      )}

      {event_type === AVAILABLE && (
        <ScheduleDeleteAvailableModal
          isRecurring={Boolean(series_id)}
          onCancel={cancelDelete}
          onSubmit={availabilityDeleteHandler}
          subTitleText={dateTimeLocal.format("MMMM D, YYYY h:mm A")}
        />
      )}
    </>
  );
}
